import React from "react";
import AudioVisualizer from "../../AudioVisualizer/AudioVisualizer";

/**
 * Footer component for the voice search modal on mobile devices
 * Contains the powered by logo and audio visualizer
 */
const Footer = ({baseUrl, isIOS, apiConfig}) => {
    return (
        <div
            className={`sm:hidden fixed ${isIOS ? 'bottom-[13%]' : 'bottom-[8%]'} w-[inherit] bg-[#F9F9F9] z-10 py-3 flex items-center justify-between`}>
            <div className="w-1/2 flex justify-start pl-2">
                {localStorage.getItem("recodemo") && localStorage.getItem("recodemo") == 1 ? (
                    <a
                        href={process.env.REACT_APP_DEMO_URL}
                        className="inline-block sm:block bg-[#0B7189] hover:bg-[#0b7189b3] rounded-[50px]
                             text-[#F9F9F9] text-[clamp(12px,1.11vw,16px)] w-48 py-4 text-center"
                        target="_blank"  // optional: open in new tab
                        rel="noopener noreferrer" // optional: security best practice
                    >
                        Go to Our Main Site
                    </a>

                ) : apiConfig?.trialPeriod?.in_trial ?
                    (
                        <img
                            src={`${baseUrl}/images/powerd_by_logo.svg`}
                            alt="Powered By Logo"
                            className="w-32 md:w-40 lg:w-48 xl:w-56 max-w-full"
                        />
                    ) : apiConfig.profileImageUrl ? (
                        <img
                            src={apiConfig.profileImageUrl}
                            alt="Company Logo"
                            className="w-32 md:w-40 lg:w-48 xl:w-56 max-w-full"
                        />
                    ) : (
                        <div className='w-32 md:w-40 lg:w-48 xl:w-56 max-w-full'></div>
                    )}
            </div>
            <div className="w-1/2 flex justify-end pr-2">
                <AudioVisualizer
                    width={window.innerWidth >= 640 ? "140" : "120"}
                    height={window.innerWidth >= 640 ? "40" : "35"}
                    color="#F9F9F9"
                    is_opning={true}
                    barCount={window.innerWidth >= 640 ? "140" : "120"}
                />
            </div>
        </div>
    );
};

export default Footer;